import { userConstants } from '../_constants';
import { userService } from '../_services';
import { alertActions } from './';

export const userActions = {
    login,
    logout,
    getAll,
    getUser,
    addUser,
    updateUser,
    delete: _delete
};

function login(username, password) {
    return dispatch => {
        dispatch(request({ username, password }));
        userService.login(username, password)
            .then(
                user => {
                    dispatch(success(user));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function logout() {
    userService.logout();
    return { type: userConstants.LOGOUT };
}


function getAll() {
    return dispatch => {
        dispatch(request());
        return userService.getAll()
            .then(
                users => {
                    dispatch(success(users));
                    return users;
                },
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: userConstants.GETALL_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_FAILURE, error } }
}

function getUser(id) {
    return dispatch => {
        dispatch(request());
        return userService.getById(id)
            .then(
                user => dispatch(success(user)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: userConstants.GETUSER_REQUEST } }
    function success(users) { return { type: userConstants.GETUSER_SUCCESS, users: users } }
    function failure(error) { return { type: userConstants.GETUSER_FAILURE, error } }
}

function addUser(user) {
    return dispatch => {
        dispatch(request(user));

        userService.addUser(user)
            .then(
                user => {
                    dispatch(success(user));
                    dispatch(alertActions.success('New user has been added successfully.'));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(user) { return { type: userConstants.ADDUSER_REQUEST, user } }
    function success(user) { return { type: userConstants.ADDUSER_SUCCESS, user } }
    function failure(error) { return { type: userConstants.ADDUSER_FAILURE, error } }
}

function updateUser(id, user) {
    return dispatch => {
        dispatch(request(user));

        userService.updateUser(id, user)
            .then(
                user => {
                    dispatch(success(user));
                    dispatch(alertActions.success('User has been updated successfully.'));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(user) { return { type: userConstants.UPDATEUSER_REQUEST, user } }
    function success(user) { return { type: userConstants.UPDATEUSER_SUCCESS, user } }
    function failure(error) { return { type: userConstants.UPDATEUSER_FAILURE, error } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    return dispatch => {
        dispatch(request(id));

        userService.delete(id)
            .then(
                user => dispatch(success(id)),
                error => dispatch(failure(id, error.toString()))
            );
    };

    function request(id) { return { type: userConstants.DELETE_REQUEST, id } }
    function success(id) { return { type: userConstants.DELETE_SUCCESS, id } }
    function failure(id, error) { return { type: userConstants.DELETE_FAILURE, id, error } }
}